import {
  LOAD_START,
  LOAD_SUCCESS,
  LOAD_FAILURE,
  LOAD_CHAN_START,
  LOAD_CHAN_SUCCESS,
  LOAD_CHAN_FAILURE,
  ADD_START,
  ADD_SUCCESS,
  ADD_FAILURE,
  GET_START,
  GET_SUCCESS,
  GET_FAILURE,
  SAVE_START,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  DELETE_START,
  DELETE_SUCCESS,
  DELETE_FAILURE,
  LOAD_CT_START,
  LOAD_CT_SUCCESS,
  LOAD_CT_FAILURE,
  CLONE_START,
  CLONE_SUCCESS,
  CLONE_FAILURE,
  TERMS_LOAD,
  TERMS_LOADED,
  TERMS_ERROR,
  NONPROFITS_LOADED
} from './actions';
import { set } from 'lodash';

const initialState = {
  loading: false,
  cloning: false,
  loadingChannels: false,
  loadingContacts: false,
  adding: false,
  asks: [],
  channels: [],
  contacts: [],
  ask: {},
  pagination: {},
  loadingTerms: false,
  nonprofits: []
};

export default (state = {}, action) => {
  let newState = Object.assign({}, initialState, state);

  switch (action.type) {
    case LOAD_START:
      newState.loading = true;
      break;
    case LOAD_SUCCESS:
      newState.loading = false;
      newState.asks = action.payload.data;
      newState.pagination = action.payload.pagination;
      break;
    case LOAD_FAILURE:
      newState.loading = false;
      break;
    case LOAD_CHAN_START:
      newState.loadingChannels = true;
      break;
    case LOAD_CHAN_SUCCESS:
      newState.loadingChannels = false;
      newState.channels = action.payload;
      break;
    case LOAD_CHAN_FAILURE:
      newState.loadingChannels = false;
      break;
    case ADD_START:
      newState.adding = true;
      break;
    case ADD_SUCCESS:
      newState.adding = false;
      break;
    case ADD_FAILURE:
      newState.adding = false;
      break;
    case GET_START:
      newState.loading = true;
      newState.ask = {};
      break;
    case GET_SUCCESS:
      newState.loading = false;
      newState.ask = action.payload.ask;
      break;
    case GET_FAILURE:
      newState.loading = false;
      break;
    case SAVE_START:
      newState.saving = true;
      break;
    case SAVE_SUCCESS:
      newState.saving = false;
      break;
    case SAVE_FAILURE:
      newState.saving = false;
      break;
    case DELETE_START:
      newState.loading = true;
      break;
    case DELETE_SUCCESS:
    case DELETE_FAILURE:
      newState.loading = false;
      break;
    case LOAD_CT_START:
      newState.loadingContacts = true;
      break;
    case LOAD_CT_SUCCESS:
      newState.loadingContacts = false;
      newState.contacts = action.payload;
      break;
    case LOAD_CT_FAILURE:
      newState.loadingContacts = false;
      break;
    case CLONE_START:
      //newState.loading = true;
      newState.cloning = true;
      break;
    case CLONE_SUCCESS:
    case CLONE_FAILURE:
      //newState.loading = false;
      newState.cloning = false;
      break;
    case TERMS_LOAD:
      newState.loadingTerms = true;
      break;
    case TERMS_LOADED:
      newState.loadingTerms = false;
      if (!newState.ask.terms) {
        newState.ask = set(newState.ask, 'terms', action.payload);
      }
      break;
    case TERMS_ERROR:
      newState.loadingTerms = false;
      break;
    case NONPROFITS_LOADED:
      newState.nonprofits = action.payload;
      break;
    default:
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/asks/reducer.js